import gql from 'graphql-tag';

export const newQuoteMutation = gql`
	mutation newQuote($input: NewQuoteInput!) {
		newQuote(input: $input) {
			guid
		}
	}
`;



// WEBPACK FOOTER //
// ./src/queries/Submit.js